import { Page } from 'components/Page/Page';
import { useTranslation } from 'react-i18next';
import { SenderEnvelopeDTO, TransactionInternalType } from 'support/types';
import { Button } from 'components/Form/Button/Button';
import { useRecoverTransaction } from 'services/repositories/transactions/transactions';
import { NotificationType, addNotification } from 'stores/notifications/notifications';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { useAnalytics } from 'support/helpers/analytics/analytics';
import { DropTransaction } from '../../DropTransaction/DropTransaction';

export const SenderEnvelopeHeader = ({ senderEnvelope }: { senderEnvelope: SenderEnvelopeDTO }) => {
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const { mutate, isLoading: isRecoveringTransaction } = useRecoverTransaction();

  const send = async () => {
    const payload = {
      id: senderEnvelope.id,
      type: TransactionInternalType.senderEnvelope,
    };

    mutate(payload, {
      onSuccess: () => {
        track('transaction_recovered', {
          transaction_id: senderEnvelope.id,
          type: TransactionInternalType.senderEnvelope,
        });

        addNotification({
          title: t('webedi:notifications.recover.successful'),
          subtitle: t('webedi:notifications.recover.successful_description'),
        });
      },
      onError: () => {
        addNotification(t('webedi:notifications.recover.failed'), NotificationType.error);
      },
    });
  };
  return (
    <Page.Head
      rightContent={
        <>
          <DropTransaction
            transactionId={senderEnvelope.id}
            canDropTransaction={senderEnvelope.canDropTransaction}
            internalType={TransactionInternalType.senderEnvelope}
          />
          {senderEnvelope.customerCanRetry ? (
            <Button
              variant="secondary-danger"
              onClick={send}
              LeftIcon={ArrowPathIcon}
              loading={isRecoveringTransaction}
              analyticsId="webedi:sender_envelope_retry"
            >
              {t('transactions:list.bulk_retrigger')}
            </Button>
          ) : null}
        </>
      }
    />
  );
};
